import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import Routes from '../src/routes'
import * as serviceWorker from './serviceWorker'
import * as Sentry from '@sentry/browser'
import { createBrowserHistory } from 'history'
const history = createBrowserHistory()

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({ dsn: 'http://fee8894a19994d01a89afc41f321ea46@sentry.yyuap.com/3' })
}

ReactDOM.render(<Routes history={history}/>, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
